var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.0031C37.2558 48.0031 48 37.2589 48 24.0031C48 10.7473 37.2558 0 24 0C10.7442 0 0 10.7442 0 24C0 37.2558 10.7442 48 24 48",
    fill: "#FF2180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5591 19.7795C14.5591 22.4178 12.4209 24.5591 9.77955 24.5591C7.13822 24.5591 5 22.4209 5 19.7795C5 17.1382 7.13822 15 9.77955 15C12.4209 15 14.5591 17.1413 14.5591 19.7795Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63842 17.9299C9.63842 18.7061 9.00954 19.335 8.2334 19.335C7.45726 19.335 6.82837 18.7061 6.82837 17.9299C6.82837 17.1538 7.45726 16.5249 8.2334 16.5249C9.00954 16.5249 9.63842 17.1538 9.63842 17.9299Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1786 20.1448C11.1786 20.5927 10.8166 20.9547 10.3687 20.9547C9.92083 20.9547 9.55884 20.5927 9.55884 20.1448C9.55884 19.697 9.92083 19.335 10.3687 19.335C10.8166 19.335 11.1786 19.697 11.1786 20.1448Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5801 19.7795C43.5801 22.4178 41.4419 24.5591 38.8005 24.5591C36.1592 24.5591 34.021 22.4209 34.021 19.7795C34.021 17.1382 36.1623 15 38.8005 15C41.4388 15 43.5801 17.1413 43.5801 19.7795Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6594 17.9299C38.6594 18.7061 38.0305 19.335 37.2544 19.335C36.4783 19.335 35.8494 18.7061 35.8494 17.9299C35.8494 17.1538 36.4783 16.5249 37.2544 16.5249C38.0305 16.5249 38.6594 17.1538 38.6594 17.9299Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1994 20.1448C40.1994 20.5927 39.8374 20.9547 39.3895 20.9547C38.9416 20.9547 38.5796 20.5927 38.5796 20.1448C38.5796 19.697 38.9416 19.335 39.3895 19.335C39.8374 19.335 40.1994 19.697 40.1994 20.1448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2093 28.6329C13.2093 29.9766 11.7429 31.0656 9.93906 31.0656C8.13522 31.0656 6.66577 29.9766 6.66577 28.6329C6.66577 27.2892 8.13215 26.2002 9.93906 26.2002C11.746 26.2002 13.2093 27.2892 13.2093 28.6329Z",
    fill: "#FFD525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9112 28.6329C41.9112 29.9766 40.4448 31.0656 38.641 31.0656C36.8371 31.0656 35.3677 29.9766 35.3677 28.6329C35.3677 27.2892 36.8341 26.2002 38.641 26.2002C40.4479 26.2002 41.9112 27.2892 41.9112 28.6329Z",
    fill: "#FFD525"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9101 33.0047C29.1217 30.6088 26.8853 28.9614 24.3698 28.897C21.8604 28.8325 19.5166 30.4523 18.6607 32.8053C18.5226 33.1857 18.1607 33.4403 17.7434 33.3268C17.3753 33.2256 17.0839 32.793 17.2219 32.4095C18.3171 29.4001 21.1517 27.3784 24.3667 27.406C27.5572 27.4337 30.3611 29.6117 31.3458 32.6089C31.6465 33.5262 30.2077 33.9158 29.9071 33.0047",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRating);
export default __webpack_public_path__ + "static/media/red_rating.271da033.svg";
export { ForwardRef as ReactComponent };